import Service from "./Service";

import pick from "lodash/pick";

export default class ModelService extends Service {
  modelPath = "";
  modelName = "";
  Model;

  constructor(modelPath, Model, modelName = null) {
    super();
    this.modelPath = modelPath;
    this.modelName = modelName;
    this.Model = Model;
  }

  /* Gets the required data for the form */
  create() {
    return new Promise((resolve, reject) => {
      this.get(config.app.api_url + this.modelPath + "/create")
        .then(data => {
          let item = new this.Model(data);
          resolve(item);
        })
        .catch(e => reject(e.response));
    });
  }

  /* Stores a value in the database */
  insert(model) {
    return new Promise((resolve, reject) => {
      this.post(
        config.app.api_url + this.modelPath,
        this.modelName ? { [this.modelName]: model } : model
      )
        .then(data => {
          let item = new this.Model(data);
          resolve(item);
        })
        .catch(e => {
          reject(e.response);
        });
    });
  }

  /* Updates the model */
  update(model) {
    return new Promise((resolve, reject) => {
      this.put(
        config.app.api_url + this.modelPath + "/" + model.id,
        this.modelName ? { [this.modelName]: model } : model
      )
        .then(data => {
          let item = new this.Model(data);
          resolve(item);
        })
        .catch(e => reject(e.response));
    });
  }

  /* Deletes the model */
  destroy(id) {
    return new Promise((resolve, reject) => {
      this.delete(config.app.api_url + this.modelPath + "/" + id)
        .then(data => {
          let item = new this.Model(data);
          resolve(item);
        })
        .catch(e => reject(e?.response ? e.response : e));
    });
  }

  search(search = null, params = { meta: {} }) {
    return new Promise((resolve, reject) => {
      this.post(config.app.api_url + this.modelPath + "/search", {
        params: {
          search,
          page: params?.meta?.page || 1,
          ...params
        }
      })
        .then(resp => {
          if (params.meta && params.meta.page) {
            resp.data = this.Model.list(resp.data);
            resp.page = resp.current_page;

            resolve(resp);
          } else {
            resolve(this.Model.list(resp));
          }
        })
        .catch(e => {
          console.log(e);
          reject(e.response);
        });
    });
  }

  find(id, qs = "") {
    return new Promise((resolve, reject) => {
      this.get(config.app.api_url + this.modelPath + "/" + id + qs)
        .then(data => {
          let item = new this.Model(data);
          resolve(item);
        })
        .catch(e => reject(e.response));
    });
  }

  findAll(options = { initObject: true }) {
    return new Promise((resolve, reject) => {
      this.get(config.app.api_url + this.modelPath)
        .then(data => {
          const items = options.initObject ? this.Model.list(data) : data;
          resolve(items);
        })
        .catch(e => reject(e.response));
    });
  }
}
